let dm_ScanQrCode;
let readedQrCode = false;
let stores = [
  {id:'0ba836c5-457e-4536-a1de-87e764fa65bc', name:'Maltepe'},
  {id:'e1e84b70-a8bf-4753-92fa-4528683c2ce0', name:'Üsküdar'},
  {id:'78234179-098a-4bfe-9b7a-74539467bdf9', name:'Avcılar'},
  {id:'223136ab-daaf-4b66-8e4f-5404fa6e94d4', name:'Kağıthane'},
  {id:'63a24a5e-5f1b-46bc-bb82-e57dfeca1e99', name:'Başakşehir'},
  {id:'4491863f-6cd8-48e2-9eb4-fc4f499d02e0', name:'Konak'},
  {id:'a9c7fd39-1ff0-4a4a-92bc-60a64511c74c', name:'Balçova'},
  {id:'c0046052-3e44-4326-900b-2299e0af15f0', name:'Ankara'},
  {id:'bc240dbe-47eb-4657-b62f-548cf1c96edb', name:'Adana'},
  {id:'e9d350b3-aa20-4fa8-bdcc-ca12488a4064', name:'Eskişehir'},
  {id:'7f16998a-2a16-4ed6-9ca0-4416ff662629', name:'Muğla'},
  {id:'daec2a27-1d18-4a52-92ff-417bbbe3103e', name:'Almanya-Berlin'},
  {id:'6942fc1b-15dc-4420-8331-adc92321baf6', name:'KKTC-Lefkoşa'},
  {id:'d8e60c67-9a7b-4e4e-999a-3f5b99086cec', name:'Bursa-Nilüfer'},
]

const GA4_MEASUREMENT_ID = 'G-XB3V3G6X94';
const GA4_STREAM_ID = '3998347908';

function dm_sendGA4Config() {
  gtag('config', GA4_MEASUREMENT_ID, {
    'send_to': GA4_MEASUREMENT_ID,
    'stream_id': GA4_STREAM_ID
  });
}
function dm_sendGA4Event(eventName, params) {
  gtag('event', eventName, {
    ...params,
    'send_to': GA4_MEASUREMENT_ID
  });
}

$(function(){
  const currentPath = window.location.pathname.replace(/\/$/, '');
  const visitId = dm_generateUniqueId();
  const visitCreatedDate = dm_generateDate();
  const trafficSource = dm_getTrafficSource();
  
  // Türkiye saatine göre zaman damgası
  const currentVisitTime = dm_generateDate();

  var exist = JSON.parse(localStorage.getItem('showroomVisit'));
  const visitData = {
    visitId: exist?.visitId ?? visitId,
    visitCreatedDate: exist?.visitCreatedDate ?? visitCreatedDate,
    trafficSource: trafficSource,
    shopifyCustomerId: window.shopifyCustomerId
  };
  localStorage.setItem('showroomVisit', JSON.stringify(visitData));

  if(location.pathname === '/pages/normod-deneyim-merkezlerimiz'){
    dm_getStoreInfo(location.href, true);
    dm_sendGA4Config();
    dm_sendGA4Event('showroom_page_visit', {
      'visit_id': visitData.visitId,
      'visit_created_date': visitData.visitCreatedDate,
      'shopify_customer_id': visitData.shopifyCustomerId,
      'traffic_source': trafficSource.source,
      'traffic_medium': trafficSource.medium,
      'traffic_campaign': trafficSource.campaign
    });
  
    $('.s-accordion button').click(function(){
      const visitData = {
        visitId: exist?.visitId ?? visitId,
        visitCreatedDate: exist?.visitCreatedDate ?? visitCreatedDate,
        visitLocation: $(this).text(),
        trafficSource: trafficSource,
        shopifyCustomerId: window.shopifyCustomerId
      };
      localStorage.setItem('showroomVisit', JSON.stringify(visitData));
      
      dm_sendGA4Event('showroom_page_location_click', {
        'visit_id': visitData.visitId,
        'visit_created_date': visitData.visitCreatedDate,
        'visit_location': $(this).text(),
        'shopify_customer_id': visitData.shopifyCustomerId
      });
    });
  
    // Check-in butonu click eventi
    $('.dm-open-camera-for-checkin').click(function(e){
      e.preventDefault();
      dm_cameraControlAndOpenModal();
      return false;
    });
  }
});

function dm_generateUniqueId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
}

function dm_generateDate() {
  return new Date().toLocaleString('tr-TR', { 
        timeZone: 'Europe/Istanbul',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
}

function dm_getTrafficSource() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get('utm_source');
  const utmMedium = urlParams.get('utm_medium');
  const utmCampaign = urlParams.get('utm_campaign');

  if (utmSource) {
    return {
      source: utmSource,
      medium: utmMedium || 'not set',
      campaign: utmCampaign || 'not set'
    };
  }

  const referrer = document.referrer;
  if (referrer) {
    const referrerDomain = new URL(referrer).hostname;
    
    if (referrerDomain.includes('instagram.com')) return { source: 'instagram', medium: 'social', campaign: 'organic' };
    if (referrerDomain.includes('facebook.com')) return { source: 'facebook', medium: 'social', campaign: 'organic' };
    if (referrerDomain.includes('google.com')) return { source: 'google', medium: 'organic', campaign: 'organic' };

    return { source: referrerDomain, medium: 'referral', campaign: 'none' };
  }

  return { source: 'direct', medium: 'none', campaign: 'none' };
}

async function dm_cameraControlAndOpenModal(){
  try {
    document.getElementById("dm-qrModal").style.display = "flex";
    document.getElementById("dm-QrReader").style.display = "none";
    document.getElementById("dm-QrReaderResult").style.display = "block";
    document.getElementById('dm-QrReaderResult').innerText = "Kamera kontrol ediliyor...";

    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter(device => device.kind === "videoinput");

    if (videoDevices.length === 0) {
      document.getElementById('dm-QrReaderResult').innerHTML = `
        <div class="error-message">
          <p>Cihazda aktif kamera bulunamadı.</p>
        </div>
      `;
    } else {
      document.getElementById("dm-QrReader").style.display = "block";
      document.getElementById("dm-QrReaderResult").style.display = "none";
      dm_startQrScanner();
    }
  } catch (error) {
    document.getElementById('dm-QrReaderResult').innerHTML = `
      <div class="error-message">
        <p>Kameraya erişim sağlanamadı. Lütfen kamera izinlerini kontrol edin.</p>
      </div>
    `;
  }
  return false;
}

function dm_startQrScanner() {
  dm_ScanQrCode = new Html5Qrcode("dm-QrReader");
  
  dm_ScanQrCode.start(
    { facingMode: "environment" },
    { fps: 1, qrbox: { width: 250, height: 250 } },
    (decodedText) => {
      dm_getStoreInfo(decodedText, false);
    },
    (error) => {}
  ).catch((err) => {
    document.getElementById('dm-QrReaderResult').innerHTML = `
      <div class="error-message">
        <p>Kamera başlatılırken bir hata oluştu: ${err.message}</p>
      </div>
    `;
  });
}

function dm_getStoreInfo(decodedText, onload){
  //var storeId = decodedText.split('&').find(z=>z.split(':')[0].indexOf('store'))?.split(':')[1];
  var storeId = dm_getUrlParam('store', decodedText);
  if(storeId){
    if(onload){
      document.getElementById("dm-qrModal").style.display = "flex";
      document.getElementById("dm-QrReader").style.display = "none";
      document.getElementById("dm-QrReaderResult").style.display = "block";
    }
    var existStore = stores.find(z=>z.id === storeId);
    if(existStore){
      dm_qrCodeResultMessage('Check-in tamamlandı. ' + existStore.name + ' deneyim merkezine hoş geldiniz. Bu ekranı sağ üstten kapatıp numune alabilirsiniz.');
      dm_sendCheckinEvent(existStore);
    } else{
      dm_qrCodeResultMessage('Eşleşen bir deneyim merkezi bulunamadı.');
    }
    setTimeout(dm_closeModal, 5000);
    
    if (dm_ScanQrCode) {
      dm_ScanQrCode.stop().then(() => {
        dm_ScanQrCode.clear();
      }).catch(err => console.error("Kamera durdurulamadı:", err));
    }
  }
}

function dm_qrCodeResultMessage(message){
  document.getElementById("dm-QrReader").style.display = "none";
  document.getElementById("dm-QrReaderResult").style.display = "block";
  document.getElementById('dm-QrReaderResult').innerText = message;
}

function dm_closeModal() {
  document.getElementById("dm-qrModal").style.display = "none";
  
  if (dm_ScanQrCode) {
    dm_ScanQrCode.stop().then(() => {
      dm_ScanQrCode.clear();
    }).catch(err => console.error("Kamera durdurulamadı:", err));
  }
  return false;
}

function dm_sendCheckinEvent(store){
  if(store){
    const checkinTime = dm_generateDate();
    var exist = JSON.parse(localStorage.getItem('showroomVisit'));

    dm_sendGA4Event('showroom_page_checkin_completed', {
      'visit_id': exist.visitId,
      'visit_created_date': exist.visitCreatedDate,
      'checkin_time': checkinTime,
      'checkin_locationid': store.id,
      'checkin_location': store.name,
      'shopify_customer_id': window.shopifyCustomerId,
      'original_traffic_source': exist?.trafficSource?.source,
      'original_traffic_medium': exist?.trafficSource?.medium,
      'original_traffic_campaign': exist?.trafficSource?.campaign
    });
  }
}

function dm_getUrlParam(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}